import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import { DeclarationModalComponent } from '../declaration-modal/declaration-modal.component';

@Component({
  selector: 'app-intent-for-eoi',
  templateUrl: './intent-for-eoi.component.html',
  styleUrls: ['./intent-for-eoi.component.css'],
})
export class IntentForEoiComponent implements OnInit {
  toppings = this._formBuilder.group({
    HostInstitutionDetails: false,
    Trackrecord: false,
    Certificate: false,
    PitchdeckofEOI: false,
    Otherdocuments: false,
  });
  settingsForm: FormGroup;
  private saveApi = environment.url + environment.intenteoiSave;
  private getApi = environment.url + 'preincubation/intenteoi/get?userId=';
  /**
   * Creates an instance of the IntentForEoiComponent.
   * @param _formBuilder The Angular form builder service.
   * @param changeDetectorRef The Angular change detector service.
   * @param media The Angular media matcher service.
   * @param router The Angular router.
   * @param fb The Angular form builder service.
   * @param makeapi The API service.
   * @param getdata The service to retrieve values or data.
   * @param notify The service to display notifications.
   * @param dialog The Angular material dialog service.
   */
  constructor(
    private _formBuilder: FormBuilder,
    private changeDetectorRef: ChangeDetectorRef,
    private media: MediaMatcher,
    private router: Router,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    public dialog: MatDialog
  ) {
    /**
     * The form group for the settings.
     */
    this.settingsForm = this.fb.group({
      id: [''],
      intentEoiId: ['0'],
      applicationId: [0],
      reasoneoifile: [''],
      reasoneoifilename: [''],
      intentletterfile: [''],
      intentletterfilename: [''],
      endorsementfile: [''],
      endorsementfilename: [''],
      pitchdeckfile: [''],
      pitchdeckfilename: [''],
      annualActivityFile: [''],
      annualActivityFileName: [''],
    });

    /**
     * The mobile query listener.
     */
    this.mobileQuery = media.matchMedia('(max-width: 992px)');
    this._mobileQueryListener = () => this.changeDetectorRef.detectChanges();
  }
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  ngAfterViewInit(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  get setting() {
    return this.settingsForm.controls;
  }
  roleName: any = '';
  /**
   * Angular lifecycle hook that is called after data-bound properties are initialized.
   * Retrieves the user's role, fetches data from the API, and checks the registration status.
   */
  ngOnInit(): void {
    // Retrieve the user's role from session storage
    this.roleName = sessionStorage.getItem('role');

    // Fetch data from the API
    this.getDataApi();

    // Check the registration status
    this.checkRegistrationStatus();
  }
  getValue: any = {};
  RegdisNames;
  TweldisNames;
  ActiondisNames;
  TrackrecdisNames;
  OtherrecdisNames;
  disNames2;
  disName3;
  disNames3;
  disName4;
  disNames4;
  disNames5;
  showForm: boolean = true;
  /**
   * Fetches data from the API, populates the form, and checks for document uploads.
   * If the API request is successful, the form is populated with the API response.
   * If the API request is not successful, the form is displayed.
   * If the user has already uploaded documents, the file upload form is hidden.
   */
  getDataApi() {
    // Reset the document upload form
    this.disNames = '';
    this.disNames2 = '';
    this.disNames3 = '';
    this.disNames4 = '';
    this.disNames5 = '';

    // Show the loading indicator
    this.getdata.amizhthLoader('show');

    // Make the API request
    this.makeapi
      .method(this.getApi + sessionStorage.getItem('userId'), '', 'get')
      .subscribe((data) => {
        // Hide the loading indicator
        this.getdata.amizhthLoader('hide');

        // Store the API response in a variable
        this.getValue = data;

        // Check if the API request was successful
        if (data.edit === false) {
          // If the API request is not successful, show the form
          this.showForm = true;
        } else {
          // If the API request is successful, hide the form
          this.showForm = false;
        }

        // Check if the user has already uploaded documents
        if (this.getValue.reasoneoifile) {
          // If the user has already uploaded the document, hide the file upload form
          this.RegFileValue = this.getValue.reasoneoifile;
          this.RegdisNames = this.getValue.reasoneoifilename;
          this.RegdisName = this.getValue.reasoneoifilename;
          this.disName = '✔ Uploaded';
          this.disNames = '✔ Uploaded';
        }
        if (this.getValue.intentletterfile) {
          // If the user has already uploaded the document, hide the file upload form
          this.TwelFileValue = this.getValue.intentletterfile;
          this.TweldisName = this.getValue.intentletterfilename;
          this.TweldisNames = this.getValue.intentletterfilename;
          this.disName2 = '✔ Uploaded';
          this.disNames2 = '✔ Uploaded';
        }
        if (this.getValue.endorsementfilename) {
          // If the user has already uploaded the document, hide the file upload form
          this.ActionFileValue = this.getValue.endorsementfile;
          this.ActiondisName = this.getValue.endorsementfilename;
          this.ActiondisNames = this.getValue.endorsementfilename;
          this.disName3 = '✔ Uploaded';
          this.disNames3 = '✔ Uploaded';
        }
        if (this.getValue.pitchdeckfilename) {
          // If the user has already uploaded the document, hide the file upload form
          this.TrackrecFileValue = this.getValue.pitchdeckfile;
          this.TrackrecdisName = this.getValue.pitchdeckfilename;
          this.TrackrecdisNames = this.getValue.pitchdeckfilename;
          this.disName4 = '✔ Uploaded';
          this.disNames4 = '✔ Uploaded';
        }
        if (this.getValue.annualActivityFileName) {
          // If the user has already uploaded the document, hide the file upload form
          this.OtherrecFileValue = this.getValue.annualActivityFile;
          this.OtherrecdisName = this.getValue.annualActivityFileName;
          this.OtherrecdisNames = this.getValue.annualActivityFileName;
          this.disName5 = '✔ Uploaded';
          this.disNames5 = '✔ Uploaded';
        }

        // Populate the form with the API response
        this.settingsForm.patchValue(this.getValue);
      });
  }

  url: any;
  fileError2 = false;
  fileError3 = false;
  fileError4 = false;
  fileError5 = false;
  userId = sessionStorage.getItem('userId');
  /**
   * Saves the form data to the server after validation checks.
   * Updates file error flags and notifies user if fields are incomplete.
   */
  saveBtn() {
    let getform = this.settingsForm.value;

    // Check if the form is invalid
    if (this.settingsForm.invalid) {
      // Validate each document field and set error flags
      this.fileError2 = this.TweldisName === '';
      this.fileError3 = this.ActiondisName === '';
      this.fileError4 = this.TrackrecdisName === '';
      this.fileError5 = this.OtherrecdisName !== '';

      // Mark all fields as touched to display validation errors
      this.settingsForm.markAllAsTouched();
      // Notify user about mandatory fields
      this.notify.notifyError('Please fill all the mandatory fields !!');
    } else {
      // Assign document values to form data if available, set error flags
      this.fileError2 = this.TwelFileValue === '';
      if (!this.fileError2) {
        getform.intentletterfile = this.TwelFileValue;
        getform.intentletterfilename = this.TweldisName;
      }

      this.fileError3 = this.ActionFileValue === '';
      if (!this.fileError3) {
        getform.endorsementfile = this.ActionFileValue;
        getform.endorsementfilename = this.ActiondisName;
      }

      this.fileError4 = this.TrackrecFileValue === '';
      if (!this.fileError4) {
        getform.pitchdeckfile = this.TrackrecFileValue;
        getform.pitchdeckfilename = this.TrackrecdisName;
      }

      this.fileError5 = this.OtherrecFileValue === '';
      if (!this.fileError5) {
        getform.annualActivityFile = this.OtherrecFileValue;
        getform.annualActivityFileName = this.OtherrecdisName;
      }

      // Proceed to save if no file errors
      if (
        !this.fileError2 &&
        !this.fileError3 &&
        !this.fileError4 &&
        !this.fileError5
      ) {
        // Show loading indicator
        this.getdata.amizhthLoader('show');
        // Add user ID to the form data
        getform.userid = this.userId;

        // Save form data via API
        this.makeapi.method(this.saveApi, getform, 'post').subscribe((data) => {
          // Hide loading indicator
          this.getdata.amizhthLoader('hide');
          if (data.responseStatus === 'Success') {
            // Refresh page and fetch data on success
            window.location.reload();
            this.getDataApi();
            this.notify.notifysuccess(data.responseMessage);
          } else {
            // Notify user of errors
            this.notify.notifyError(data.responseMessage);
          }
        });
      }
    }
  }
  /**
   * Handles the submit button click event. Opens a modal dialog box for user confirmation.
   * On successful submission, redirects the user to the dashboard.
   */
  submitBtn() {
    const dialogRef = this.dialog.open(DeclarationModalComponent, {
      data: { title: '' },
    });

    // Handle the modal dialog box close event
    dialogRef.afterClosed().subscribe((result) => {
      // Redirect to the dashboard
      this.router.navigate(['admin', 'pre-incubation', 'dashboard', {}]);
    });
  }

  step = 0;
  setStep(index: number) {
    this.step = index;
  }
  nextStep() {
    this.saveBtn();
  }
  prevStep() {
    this.step--;
  }
  selecetdRegFile: any = [];
  urlReg: any;
  RegFileValue: any = '';
  RegFileName: any;
  documentRegValues = [];
  RegdisName;
  disName;
  disNames;
  fileError1 = false;
  maxSizeMB = 10;
  logoCheck = false;

  /**
   * Handles the file upload for registration documents.
   * Validates the file type and size, reads the file as a data URL,
   * and updates the form with the file's data and name.
   *
   * @param event - The file input change event.
   */
  fileRegUpload(event) {
    // Select the first file from the event
    this.selecetdRegFile = event.target.files[0];

    if (event.target.files && this.selecetdRegFile) {
      // Calculate the file size in MB
      const fileSizeMB = this.selecetdRegFile.size / (1024 * 1024);

      // Check if the file size exceeds the maximum allowed size
      if (fileSizeMB > this.maxSizeMB) {
        this.logoCheck = true;
        return;
      }

      let reader = new FileReader();
      let imagetype = this.selecetdRegFile.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];

      // Validate the file type
      if (img_crt_type == 'pdf') {
        reader.readAsDataURL(this.selecetdRegFile);
        reader.onload = () => {
          // On successful file read, update the URL and form values
          this.urlReg = reader.result;
          let spl = this.urlReg.split(',');
          this.RegFileValue = spl[1];
          this.RegFileName = this.selecetdRegFile.name;
          this.RegdisName = this.selecetdRegFile.name;
          this.disName = '✔ Uploaded';
          this.fileError1 = false;

          // Update the form with the file data
          let getform = this.settingsForm.value;
          getform.reasoneoifilename = this.selecetdRegFile.name;
          getform.reasoneoifile = this.RegFileValue;
          this.settingsForm.patchValue(getform);
        };
      } else {
        // Notify the user if the file type is not allowed
        this.notify.notifyError(
          'Only *jpeg,*jpg,*png,*pdf formats are allowed'
        );
      }
    }
  }
  selecetdTwelFile: any = [];
  urlTwel: any;
  TwelFileValue: any = '';
  TwelFileName: any;
  TweldisName;
  disName2;
  twllogoCheck = false;
  /**
   * Handles the file upload for the twel document.
   * Validates the file type and size, reads the file as a data URL,
   * and updates the form with the file's data and name.
   *
   * @param event - The file input change event.
   */
  twelldocfileUpload(event) {
    this.selecetdTwelFile = event.target.files[0];
    if (event.target.files && this.selecetdTwelFile) {
      // Calculate the file size in MB
      const fileSizeMB = this.selecetdTwelFile.size / (1024 * 1024);

      // Check if the file size exceeds the maximum allowed size
      if (fileSizeMB > this.maxSizeMB) {
        this.twllogoCheck = true;
        return;
      }

      let reader = new FileReader();
      let imagetype = this.selecetdTwelFile.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];

      // Validate the file type
      if (img_crt_type == 'pdf') {
        reader.readAsDataURL(this.selecetdTwelFile);
        reader.onload = () => {
          // On successful file read, update the URL and form values
          this.urlTwel = reader.result;
          let spl = this.urlTwel.split(',');
          this.TwelFileValue = spl[1];
          this.TwelFileName = this.selecetdTwelFile.name;
          this.TweldisName = this.selecetdTwelFile.name;
          this.disName2 = '✔ Uploaded';
          let getform = this.settingsForm.value;
          getform.intentletterfile = this.TwelFileValue;
          getform.intentletterfilename = this.selecetdTwelFile.name;
          this.fileError2 = false;
        };
      } else {
        // Notify the user if the file type is not allowed
        this.notify.notifyError('Only *pdf formets are allowed');
      }
    }
  }
  selecetdActionFile: any = [];
  urlAction: any;
  ActionFileValue: any = '';
  ActionFileName: any;
  ActiondisName;
  actionlogoCheck = false;
  fileErrorShow1 = false;
  /**
   * Handles the file upload for the action plan document.
   * Validates the file type and size, reads the file as a data URL,
   * and updates the form with the file's data and name.
   *
   * @param event - The file input change event.
   */
  actiondocfileUpload(event) {
    this.selecetdActionFile = event.target.files[0];
    if (event.target.files && this.selecetdActionFile) {
      // Calculate the file size in MB
      const fileSizeMB = this.selecetdActionFile.size / (1024 * 1024);

      // Check if the file size exceeds the maximum allowed size
      if (fileSizeMB > this.maxSizeMB) {
        this.actionlogoCheck = true;
        this.fileErrorShow1 = true;
        return;
      }

      let reader = new FileReader();
      let imagetype = this.selecetdActionFile.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];

      // Validate the file type
      if (img_crt_type == 'pdf') {
        reader.readAsDataURL(this.selecetdActionFile);
        reader.onload = () => {
          // On successful file read, update the URL and form values
          this.urlAction = reader.result;
          let spl = this.urlAction.split(',');
          this.ActionFileValue = spl[1];
          this.ActionFileName = this.selecetdActionFile.name;
          this.ActiondisName = this.selecetdActionFile.name;
          this.disName3 = '✔ Uploaded';
          let getform = this.settingsForm.value;
          getform.endorsementfile = this.ActionFileValue;
          getform.endorsementfilename = this.selecetdActionFile.name;
          this.fileError3 = false;
          this.settingsForm.patchValue(getform);
        };
      } else {
        // Notify the user if the file type is not allowed
        this.notify.notifyError('Only *pdf formets are allowed');
      }
    }
  }
  selecetdTrackrecFile: any = [];
  urlTrackrec: any;
  TrackrecFileValue: any = '';
  TrackrecFileName: any;
  TrackrecdisName;
  TracklogoCheck = false;
  /**
   * Handles the file upload for the track record document.
   * Validates the file type and size, reads the file as a data URL,
   * and updates the form with the file's data and name.
   *
   * @param event - The file input change event.
   */
  trackrecdocfileUpload(event) {
    this.selecetdTrackrecFile = event.target.files[0];
    if (event.target.files && this.selecetdTrackrecFile) {
      const fileSizeMB = this.selecetdTrackrecFile.size / (1024 * 1024);
      if (fileSizeMB > this.maxSizeMB) {
        // If the file size exceeds the maximum allowed size, set an error flag
        this.TracklogoCheck = true;
        return;
      }
      let reader = new FileReader();
      let imagetype = this.selecetdTrackrecFile.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];

      // Validate the file type
      if (img_crt_type == 'pdf') {
        // If the file type is valid, read the file as a data URL
        reader.readAsDataURL(this.selecetdTrackrecFile);
        reader.onload = () => {
          // On successful file read, update the URL and form values
          this.urlTrackrec = reader.result;
          let spl = this.urlTrackrec.split(',');
          this.TrackrecFileValue = spl[1];
          this.TrackrecFileName = this.selecetdTrackrecFile.name;
          this.TrackrecdisName = this.selecetdTrackrecFile.name;
          this.disName4 = '✔ Uploaded';
          let getform = this.settingsForm.value;
          getform.pitchdeckfile = this.TrackrecFileValue;
          getform.pitchdeckfilename = this.selecetdTrackrecFile.name;
          // Clear any file-related errors
          this.fileError4 = false;
        };
      } else {
        // If the file type is not valid, notify the user
        this.notify.notifyError('Only *pdf formets are allowed');
      }
    }
  }

  selecetdOtherrecFile: any = [];
  urlOtherrec: any;
  OtherrecFileValue: any = '';
  OtherrecFileName: any;
  OtherrecdisName;
  otherlogoCheck = false;
  disName5;
  /**
   * Uploads the Other Reason EOI document
   * @param event Event fired when the file input is changed
   */
  otherrecdocfileUpload(event) {
    this.selecetdOtherrecFile = event.target.files[0];
    if (event.target.files && this.selecetdOtherrecFile) {
      // Check if the file size is within the allowed limit
      const fileSizeMB = this.selecetdOtherrecFile.size / (1024 * 1024);
      if (fileSizeMB > this.maxSizeMB) {
        this.otherlogoCheck = true;
        return;
      }

      let reader = new FileReader();
      // Get the file type of the selected file
      let imagetype = this.selecetdOtherrecFile.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];

      // Validate the file type
      if (img_crt_type == 'pdf') {
        // If the file type is valid, read the file as a data URL
        reader.readAsDataURL(this.selecetdOtherrecFile);
        reader.onload = () => {
          // On successful file read, update the URL and form values
          this.urlOtherrec = reader.result;
          let spl = this.urlOtherrec.split(',');
          this.OtherrecFileValue = spl[1];
          this.OtherrecFileName = this.selecetdOtherrecFile.name;
          this.OtherrecdisName = this.selecetdOtherrecFile.name;
          this.disName5 = '✔ Uploaded';
          // Update the form values
          let getform = this.settingsForm.value;
          getform.annualActivityFile = this.OtherrecFileValue;
          getform.annualActivityFileName = this.selecetdOtherrecFile.name;
          // Clear any file-related errors
          this.fileError5 = false;
        };
      } else {
        // If the file type is not valid, notify the user
        this.notify.notifyError('Only *pdf formets are allowed');
      }
    }
  }

  /**
   * Resets the incorporation image selection and clears the form values
   */
  deleteIncorporationImage() {
    // Reset the incorporation image selection
    this.RegdisName = '';

    // Get the current form values
    let getform = this.settingsForm.value;

    // Clear the reason for EOI form values
    getform.reasoneoifile = '';
    this.settingsForm.controls['reasoneoifile'].setValue('');
    this.settingsForm.controls['reasoneoifile'].updateValueAndValidity();

    // Update the form with the cleared values
    this.settingsForm.patchValue(getform);
  }

  /**
   * Resets the Twlaa80g document selection and clears the form values.
   */
  deleteTwlaa80gImage() {
    // Reset the displayed name for the Twlaa80g document
    this.TweldisName = '';

    // Get the current form values
    let getform = this.settingsForm.value;

    // Clear the Twlaa80g document form values
    getform.intentletterfile = '';
    this.settingsForm.controls['intentletterfile'].setValue('');
    this.settingsForm.controls['intentletterfile'].updateValueAndValidity();

    // Update the form with the cleared values
    this.settingsForm.patchValue(getform);
  }

  /**
   * Resets the action plan image selection and clears the form values.
   */
  deleteActionPlanImage() {
    // Reset the displayed name for the action plan document
    this.ActiondisName = '';

    // Get the current form values
    let getform = this.settingsForm.value;

    // Clear the endorsement file form value
    getform.endorsementfile = '';
    this.settingsForm.controls['endorsementfile'].setValue('');
    this.settingsForm.controls['endorsementfile'].updateValueAndValidity();

    // Update the form with the cleared values
    this.settingsForm.patchValue(getform);
  }

  /**
   * Resets the track record image selection and clears the form values.
   */
  deleteTrackRecordImage() {
    // Reset the displayed name for the track record document
    this.TrackrecdisName = '';

    // Get the current form values
    let getform = this.settingsForm.value;

    // Clear the track record document form value
    getform.pitchdeckfile = '';

    // Update the form with the cleared values
    this.settingsForm.controls['pitchdeckfile'].setValue('');
    this.settingsForm.controls['pitchdeckfile'].updateValueAndValidity();
    this.settingsForm.patchValue(getform);
  }
  isRegistrationClosedPre: boolean = false;
  /**
   * Checks if the registration is closed
   * @description Checks if the current date is after the registration deadline
   */
  checkRegistrationStatus(): void {
    const deadline = new Date(2026, 2, 31, 23, 59, 0); // March 7, 2025, 5:01 PM
    const now = new Date();
    this.isRegistrationClosedPre = now >= deadline;
  }
}
